// extracted by mini-css-extract-plugin
export default {"tooltip":"CustomTooltip_tooltip__nF4T+","title":"CustomTooltip_title__ucDSp"};